import { DatasourceIdToConnectionIdsMap } from '../types/DatasourceIdToConnectionIdsMap';
import { Request } from './Request';

export class GetDataConnectionIdsFromDatasourcesRequest extends
    Request<{ datasourceIds: string[] }, DatasourceIdToConnectionIdsMap> {
  constructor(datasourceIds: string[]) {
    super('getDataConnectionIdsFromDatasources', { datasourceIds });
  }
}
